import React, { useEffect, useState } from "react";
import $ from "jquery";
import "bootstrap-datepicker";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css";
import moment from "moment";
import FiltersBoxUi from "./FiltersBoxUi";
import "select2/dist/css/select2.min.css"; // Import Select2 CSS
import "select2"; // Import Select2 JS
import { useDispatch, useSelector } from "react-redux";
import { useGetCenQuery } from "../../store/Api/cen";
import { setSelectedCENId } from "../../store/cenSlice";
function FiltersBox({
  selectData,
  setFiltersId,
  refetchStates,
  refetchcity,
  setSelectData,
  filtersId,
  applyFilter,
  removeFilter,
  decodedToken,
}) {
  const dispatch = useDispatch();
  const selectedCEN = useSelector((state) => state.cen.selectedCEN);
  const [isFilter,setIsFilter]=useState(false)
  const [showModal,setShowModal]=useState(false);
  const [cenSearch,setCenSearch]=useState({search:""});
  const { data :cenData ,refetch} = useGetCenQuery({
    search:cenSearch?.search ? cenSearch?.search :""  ,
    limit: "",
    page: "",
  });
  useEffect(() => {
    // Initialize select2 with Bootstrap theme
    $("#filter_date_reservation").daterangepicker(
      {
        // Set startDate to one month ago and endDate to today
        startDate: filtersId?.startDate !== "" 
          ? moment(filtersId?.startDate, "DD-MM-YYYY") 
          : moment().subtract(1, "month").startOf("day"),
        endDate: filtersId?.endDate !== "" 
          ? moment(filtersId?.endDate, "DD-MM-YYYY") 
          : moment().endOf("day"),
        locale: {
          format: "DD-MM-YYYY",
        },
      },
      function (start, end) {
        setFiltersId({
          ...filtersId,
          startDate: moment(start).format("DD-MM-YYYY"),
          endDate: moment(end).format("DD-MM-YYYY"),
        });
      }
    );
  
    if (filtersId.startDate && filtersId.endDate) {
      $("#filter_date_reservation").val(
        `${filtersId.startDate} to ${filtersId.endDate}`
      );
    } else {
      $("#filter_date_reservation").val(
        `${moment().subtract(1, "month").startOf("day").format("DD-MM-YYYY")} to ${moment().endOf("day").format("DD-MM-YYYY")}`
      );
    }
  
    // Cleanup on component unmount
    return () => {
      $("#filter_date_reservation").data("daterangepicker")?.remove();
    };
  }, [filtersId]);
  
  useEffect(() => {
    $(".select2bs4").select2({
      theme: "bootstrap4",
    });
    // Handle change event and sync with Formik state
    $(".select2bs4").on("change", (e) => {
      const { name, value } = e.target;
      if (name === "rrb_id") {
        setSelectData({
          ...selectData,
          states: [],
          city: [],
          centre: [],
        });
        setFiltersId({
          ...filtersId,
          rrbId: value,
          stateId: "",
          cityId: "",
          centreId: "",
        });
      } else if (name === "state_id") {
        setFiltersId({
          ...filtersId,
          stateId: value,
          cityId: "",
          centreId: "",
        });
        if (name === "state_id" && value === "") {
          setSelectData({
            ...selectData,
            city: [],
            centre: [],
          });
        }
      } else if (name === "city_id") {
        setFiltersId({
          ...filtersId,
          cityId: value,
          centreId: "",
        });
        if (name === "city_id" && value === "") {
          setSelectData({
            ...selectData,
            centre: [],
          });
        }
      } else if (name === "centre_id") {
        setFiltersId({
          ...filtersId,
          centreId: value,
        });
        // if (name === "city_id" && value === "") {
        //   setSelectData({
        //     ...selectData,
        //     centre: [],
        //   });
        // }
      }
      if (name === "auditor_id") {
        setFiltersId({
          ...filtersId,
          auditorId: value,
        });
      }
      if(name === "status"){
        setFiltersId({
          ...filtersId,
          status: e.target.value,
        });
      }
      if(name === "audit_status"){
        setFiltersId({
          ...filtersId,
          audit_status: e.target.value,
        });
      }
    });

    // Cleanup on unmount
    return () => {
      $(".select2bs4").select2("destroy");
    };
  }, [refetchStates, refetchcity, filtersId]);
  const handleRadioChange = (e) => {
    setFiltersId({
      ...filtersId,
      status: e.target.value,
    });
  };
  useEffect(() => {
    if (cenData && cenData?.data?.data.length > 0) {
      if (!selectedCEN?.cenId) {
        const cenDatad = cenData?.data?.data;
        const id = cenDatad[0]?.id;
        const name = cenDatad[0]?.name;
        dispatch(setSelectedCENId({ cenId: id, name: name }));
        if(!filtersId?.cen_id){
        setFiltersId({
          ...filtersId,
          cen_id: id,
        });}
      } else {
      
        // setFiltersId({
        //   ...filtersId,
        //   cen_id: selectedCEN?.cenId,
        // });
    
      }
    }
  }, [cenData]);
    
     useEffect(() => {
    if(cenSearch){
      refetch();
    }
     },[cenSearch])
  return (
    <div>
      <FiltersBoxUi
        selectData={selectData}
        filtersId={filtersId}
        applyFilter={applyFilter}
        removeFilter={removeFilter}
        decodedToken={decodedToken}
        handleRadioChange={handleRadioChange}
        isFilter={isFilter}
        setIsFilter={setIsFilter}
        setFiltersId={setFiltersId}
        setShowModal={setShowModal}
        showModal={showModal}
        setCenSearch={setCenSearch}
        cenSearch={cenSearch}
        selectedCEN={selectedCEN}
        cenData={cenData?.data?.data}
      />
    </div>
  );
}

export default FiltersBox;
